import styled from '@emotion/styled';

export const ReportCardContainer = styled.section`
  width: 100%;
  max-width: 500px;
  min-width: 400px;
  height: 200px;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  background: #ffffff;
  box-sizing: border-box;
  position: relative;
  opacity: ${({ isProcessing }) => isProcessing ? 0.7 : 1};
  pointer-events: ${({ isProcessing }) => isProcessing ? 'none' : 'auto'};
  transition: opacity 0.2s ease;
  
  @media (max-width: 1200px) {
    max-width: 100%;
    min-width: 300px;
  }
`;

export const ProcessingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  z-index: 10;
  gap: 12px;
`;

export const ProcessingSpinner = styled.div`
  width: 24px;
  height: 24px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #6A42F2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

export const ProcessingText = styled.div`
  color: #6A42F2;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
`;

export const ReportHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 20px 24px 0;
  min-height: 45px;
`;

export const ReportTitle = styled.h3`
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 16px;
  line-height: 22px;
  font-weight: 600;
  margin: 0;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 8px;
`;

export const ReportInfo = styled.div`
  padding: 12px 24px 0;
`;

export const ReportDescription = styled.p`
  color: #666666;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  line-height: 18px;
  font-weight: 400;
  margin: 0 0 8px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ReportMetadata = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const SheetsCount = styled.div`
  color: #999999;
  font-family: "Inter", sans-serif;
  font-size: 11px;
  line-height: 14px;
  font-weight: 400;
`;

export const UpdateDate = styled.div`
  color: #999999;
  font-family: "Inter", sans-serif;
  font-size: 11px;
  line-height: 14px;
  font-weight: 400;
`;

export const ReportActions = styled.div`
  position: absolute;
  top: 20px;
  right: 24px;
  display: flex;
  gap: 8px;
`;

export const ActionIcon = styled.button`
  width: 28px;
  height: 28px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  border-radius: 4px;
  
  &:hover:not(:disabled) {
    background: #f3f4f6;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  ${({ type }) => {
    if (type === 'copy') {
      return `
        &::before {
          content: '📋';
          font-size: 14px;
        }
      `;
    } else if (type === 'delete') {
      return `
        &::before {
          content: '🗑️';
          font-size: 14px;
        }
        
        &:hover:not(:disabled) {
          background: rgba(239, 68, 68, 0.1);
        }
      `;
    }
  }}
`;

export const ButtonGroup = styled.div`
  position: absolute;
  bottom: 16px;
  right: 24px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
  
  @media (max-width: 1200px) {
    position: static;
    margin: 16px 24px;
    justify-content: center;
  }
`;

export const ActionButton = styled.button`
  height: 32px;
  padding: 0 12px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all 0.2s ease;
  white-space: nowrap;
  min-width: 80px;
  
  ${({ variant }) => {
    if (variant === 'primary') {
      return `
        background: #6A42F2;
        &:hover:not(:disabled) { background: #5936e8; }
      `;
    } else if (variant === 'secondary') {
      return `
        background: #10b981;
        &:hover:not(:disabled) { background: #059669; }
      `;
    }
  }}
  
  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
    opacity: 0.7;
  }
  
  @media (max-width: 1200px) {
    min-width: 90px;
    height: 36px;
    font-size: 13px;
  }
`;